const UNKNOWN = 'N/A';

export const SHORTEN_LARGE_NUMBER_CONFIG = {
    1_000_000: 'M',
};

export const SHORTEN_NUMBER_CONFIG = {
    1_000: 'K',
    ...SHORTEN_LARGE_NUMBER_CONFIG
};

const DISPLAY_TYPE = {
    PERCENTAGE: 'percentage',
    CURRENCY: 'currency',
    NUMBER: 'number',
};

const getFixedNumber = (number, maximumFractionDigits = 2) =>
    new Intl.NumberFormat('en-US', { maximumFractionDigits }).format(number);

const formatBigNumber = (number, numberSize, suffix) => {
    return `${getFixedNumber(number / numberSize, 0)}${suffix}`;
};

const formattedMetricNumericValue = (metricValue, isFullNumber, shortenConfig = SHORTEN_NUMBER_CONFIG) => {
    if (!metricValue) return UNKNOWN;
    if (isFullNumber) return Intl.NumberFormat().format(metricValue);

    for (const scalingFactor of Object.keys(shortenConfig)
        .sort()
        .reverse()) {
        const symbol = shortenConfig[scalingFactor];
        if (metricValue >= scalingFactor) return formatBigNumber(metricValue, scalingFactor, symbol);
    }

    return getFixedNumber(metricValue);
};

const formattedPercentageValue = (metricValue, isFullNumber) => {
    if (!metricValue) return UNKNOWN;
    const percentageValue = metricValue * 100;
    return `${isFullNumber ? percentageValue : getFixedNumber(percentageValue)}%`;
};

export const getFormattingFunction = (displayFormat, shortenConfig) => {
    const { type, symbol = '' } = displayFormat;

    const formatMethod = type === DISPLAY_TYPE.PERCENTAGE
        ? formattedPercentageValue
        : (metricValue, isFullNumber) => formattedMetricNumericValue(metricValue, isFullNumber, shortenConfig);

    return [formatMethod, symbol];
};

export const formatSymbol = (value, symbol) => {
    if (!symbol || value === UNKNOWN) return value;

    return `${symbol} ${value}`;
};
